<template>
  <div>
    <Navbar />
    <Slider />
    <Section1 :row="row" />
    <Section2 :row="row" />
    <Section3 :row="row" />
    <Section4 :row="row" />
    <Footer :containerFluidHome="true" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Section1 from "./Section1.vue";
import Section2 from "./Section2.vue";
import Section3 from "./Section3.vue";
import Section4 from "./Section4.vue";
import Slider from "./Slider.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";

export default {
  name: "Home",
  components: {
    Navbar,
    Section1,
    Section2,
    Section3,
    Section4,
    Slider,
    Footer,
  },
  data() {
    return {
      pgLoading: true,
      row: '',
    };
  },
  watch: {
    $route() {
      this.fetchHome();
    },
  },
  created() {
    // Check Auth
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    this.fetchHome();
  },
  methods: {
   

    fetchHome() {
      axios
        .get(window.baseURL + "/landingPages")
        .then((res) => {
          this.pgLoading = false;
          this.row = res.data.row;
          console.log(res.data.row);
        })
        .catch(() => {});
    },


  },
};
</script>
